import React, { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { PlanTypesOptions } from '../enrollmentModal.types';

import { EnrollmentFormField, EnrollmentFormFields } from './useEnrollmentForm';

interface UseEnrollmentModalActionsProps {
  currentModalVisible: boolean;
  prevModalVisibleRef: React.RefObject<boolean>;
  methods: UseFormReturn<EnrollmentFormFields>;
  defaultFormValues: EnrollmentFormFields;
  setErrorModal: (val: boolean) => void;
  currentSetModalVisible: (val: boolean) => void;
  setSelectedPlanId: (id: string | undefined) => void;
  setSelectedHealthPlanId: (id: string | undefined) => void;
  clearConflictMessage: () => void;
}

export const useEnrollmentModalActions = ({
  currentModalVisible,
  prevModalVisibleRef,
  methods,
  defaultFormValues,
  setErrorModal,
  currentSetModalVisible,
  setSelectedPlanId,
  setSelectedHealthPlanId,
  clearConflictMessage,
}: UseEnrollmentModalActionsProps) => {
  useEffect(() => {
    if (currentModalVisible) {
      methods.reset({
        ...defaultFormValues,
        type: methods.getValues(EnrollmentFormField.type),
      });
    }

    if (prevModalVisibleRef.current && !currentModalVisible) {
      setSelectedPlanId(undefined);
      setSelectedHealthPlanId(undefined);
      methods.reset({
        type: PlanTypesOptions[0]?.value,
      });
      setErrorModal(false);
      clearConflictMessage();
    }
    prevModalVisibleRef.current = currentModalVisible;
  }, [
    currentModalVisible,
    defaultFormValues,
    methods,
    prevModalVisibleRef,
    setErrorModal,
    setSelectedPlanId,
    setSelectedHealthPlanId,
    clearConflictMessage,
  ]);

  const handleCancel = () => {
    currentSetModalVisible(false);
    setErrorModal(false);
  };

  const handleTryAgain = () => {
    setErrorModal(false);
  };

  return {
    handleCancel,
    handleTryAgain,
  };
};
